// extracted by mini-css-extract-plugin
module.exports = {"root":"CanvasCancellationPolicy_root__oupQp"};